const FAILURE_THRESHOLD = 2;

let consecutiveFailures = 0;
let isDown = false;
const listeners = new Set();

function notify() {
  listeners.forEach((l) => l(isDown));
}

export function reportSuccess() {
  consecutiveFailures = 0;
  if (isDown) {
    isDown = false;
    notify();
  }
}

/**
 * UN FRENO NO ES UNA CAIDA, y por eso un 429 no cuenta aqui.
 *
 * La condicion de abajo lo deja fuera sola -429 no llega a 500-, pero conviene que este dicho:
 * sacar la pantalla de reconexion por un 429 seria decirle al alumno que el servicio se ha caido
 * cuando lo que pasa es que va muy rapido, y ademas la pantalla reintenta, o sea que echaria mas
 * leña justo al fuego que hay. Quien avisa del freno es `lib/api/client.js`, con un aviso y la
 * espera que manda el servidor.
 */
export function reportFailure(error) {
  const isNetworkOrServerError =
    !error?.response || error.response.status >= 500 || error.code === "ERR_NETWORK";
  if (!isNetworkOrServerError) return;
  consecutiveFailures += 1;
  if (consecutiveFailures >= FAILURE_THRESHOLD && !isDown) {
    isDown = true;
    notify();
  }
}

export function forceUp() {
  consecutiveFailures = 0;
  if (isDown) {
    isDown = false;
    notify();
  }
}

export function getIsDown() {
  return isDown;
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
